import React from "react";
import { Modal } from "react-bootstrap";
import "./EndCallConfirmationModal.css";

const EndCallConfirmationModal = ({ show, onConfirm, onCancel, container }) => (
    <Modal
        show={show}
        onHide={onCancel}
        container={container}
        backdrop="static"
        centered
        size="sm"
        className="zoom-end-call-modal"
        aria-labelledby="zoom-end-call-modal-title"
        aria-describedby="zoom-end-call-modal-description"
    >
        <Modal.Header closeButton className="zoom-end-call-modal__header">
            <Modal.Title id="zoom-end-call-modal-title">End call?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="zoom-end-call-modal__body">
            <p id="zoom-end-call-modal-description">
                Are you sure you want to disconnect this call?
            </p>
        </Modal.Body>
        <Modal.Footer className="zoom-end-call-modal__footer">
            <button
                type="button"
                className="zoom-end-call-modal__button zoom-end-call-modal__button--cancel"
                onClick={onCancel}
            >
                No, keep call
            </button>
            <button
                type="button"
                className="zoom-end-call-modal__button zoom-end-call-modal__button--confirm"
                onClick={onConfirm}
            >
                Yes, end call
            </button>
        </Modal.Footer>
    </Modal>
);

export default EndCallConfirmationModal;
